export const setList = (state, payload) => state.list = payload;
export const setListExceptId = (state, payload) => state.listExceptId = payload;
export const removeItem = (state, id) => state.list = state.list.filter(item => item.id !== id);
